function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M0,52.53l2.32-4.56c4,3.92,11.11,6.8,18.47,6.8,10.47,0,15.03-4.4,15.03-9.91,0-15.35-34.46-5.92-34.46-26.63C1.36,9.99,7.76,2.88,21.99,2.88c6.32,0,12.87,1.84,17.35,4.96l-2,4.72c-4.8-3.12-10.39-4.64-15.35-4.64-10.23,0-14.79,4.56-14.79,10.15,0,15.35,34.46,6.08,34.46,26.47,0,8.24-6.56,15.27-20.87,15.27-8.4,0-16.63-2.96-20.79-7.28Z",
  fill: "#fff"
});

var _ref3 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M68.92,38.22l-9.91,9.12v11.99h-5.68V0h5.68v40.22l25.11-22.95h7.04l-17.99,17.19,19.67,24.87h-6.96l-16.95-21.11Z",
  fill: "#fff"
});

var _ref4 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M134.57,17.27l-21.03,47.09c-3.52,8.24-8,10.87-13.99,10.87-3.92,0-7.68-1.28-10.23-3.84l2.64-4.24c2.08,2.08,4.64,3.2,7.68,3.2,3.76,0,6.32-1.76,8.72-7.04l1.84-4.08-18.79-41.98h5.92l15.83,35.74,15.83-35.74h5.6Z",
  fill: "#fff"
});

var _ref5 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M177.98,40.06h-35.18c.64,8.79,7.36,14.63,16.55,14.63,5.12,0,9.67-1.84,12.87-5.52l3.2,3.68c-3.76,4.48-9.59,6.88-16.23,6.88-13.11,0-22.07-8.96-22.07-21.43s8.72-21.35,20.55-21.35,20.39,8.72,20.39,21.35c0,.48-.08,1.12-.08,1.76ZM142.8,35.82h29.82c-.72-8.24-6.72-13.99-14.95-13.99s-14.15,5.76-14.87,13.99Z",
  fill: "#fff"
});

var _ref6 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M251.86,60.21l-7.76-8c-4.72,5.04-11.11,7.6-18.71,7.6-10.95,0-18.79-5.76-18.79-14.23,0-6.64,3.84-11.51,14.07-17.43-5.44-5.6-7.04-8.96-7.04-13.27,0-7.12,5.52-11.91,14.15-11.91,7.92,0,13.03,4.16,13.03,11.11,0,5.6-3.36,9.51-12.47,14.79l15.35,15.83c1.68-2.96,2.96-6.56,3.76-10.79l4.64,1.44c-1.04,5.04-2.72,9.35-4.96,12.87l8,8.24-3.28,3.76ZM240.75,48.77l-16.87-17.35c-8.96,5.12-11.67,8.63-11.67,13.59,0,6.08,5.44,10.08,13.51,10.08,6.08,0,11.19-2.08,15.03-6.32ZM218.92,14.79c0,3.28,1.2,5.6,6.32,10.79,8.08-4.64,10.71-7.44,10.71-11.43s-2.96-6.96-8.16-6.96c-5.6,0-8.88,3.12-8.88,7.6Z",
  fill: "#fff"
});

var _ref7 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M280.89,52.53l2.32-4.56c4,3.92,11.11,6.8,18.47,6.8,10.47,0,15.03-4.4,15.03-9.91,0-15.35-34.46-5.92-34.46-26.63,0-8.24,6.4-15.35,20.63-15.35,6.32,0,12.87,1.84,17.35,4.96l-2,4.72c-4.8-3.12-10.39-4.64-15.35-4.64-10.23,0-14.79,4.56-14.79,10.15,0,15.35,34.46,6.08,34.46,26.47,0,8.24-6.56,15.27-20.87,15.27-8.4,0-16.63-2.96-20.79-7.28Z",
  fill: "#fff"
});

var _ref8 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M372.92,34.94v24.39h-5.68v-23.83c0-8.88-4.64-13.43-12.63-13.43-9.04,0-14.71,5.6-14.71,15.19v22.07h-5.68V0h5.68v24.63c3.12-4.88,8.63-7.68,15.75-7.68,10.23,0,17.27,5.92,17.27,17.99Z",
  fill: "#fff"
});

var _ref9 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M384.27,38.3c0-12.47,9.12-21.35,21.43-21.35s21.35,8.88,21.35,21.35-9.03,21.43-21.35,21.43-21.43-8.96-21.43-21.43ZM421.29,38.3c0-9.83-6.64-16.39-15.59-16.39s-15.67,6.56-15.67,16.39,6.72,16.39,15.67,16.39,15.59-6.56,15.59-16.39Z",
  fill: "#fff"
});

var _ref10 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M459.83,16.95v5.52c-.48,0-.96-.08-1.36-.08-8.8,0-14.15,5.6-14.15,15.51v21.43h-5.68V17.27h5.44v8.24c2.64-5.6,8-8.56,15.75-8.56Z",
  fill: "#fff"
});

var _ref11 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M506.28,40.06h-35.18c.64,8.79,7.36,14.63,16.55,14.63,5.12,0,9.67-1.84,12.87-5.52l3.2,3.68c-3.76,4.48-9.59,6.88-16.23,6.88-13.11,0-22.07-8.96-22.07-21.43s8.72-21.35,20.55-21.35,20.39,8.72,20.39,21.35c0,.48-.08,1.12-.08,1.76ZM471.1,35.82h29.82c-.72-8.24-6.72-13.99-14.95-13.99s-14.15,5.76-14.87,13.99Z",
  fill: "#fff"
});

var SvgSkyeAndShore = function SvgSkyeAndShore(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    viewBox: "0 0 506.36 75.24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSkyeAndShore, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "SkyeAndShore.svg";
export { ForwardRef as ReactComponent };